import { useCallback } from 'react';

import {
  useCreateGiftCardPaymentIntentMutation,
  type CreateGiftCardPaymentIntentMutationVariables,
} from '../../graphql/GiftCardPaymentIntent.generated';

/**
 * Creates a payment intent for the selected gift card.
 */
export const useGiftCardPaymentIntent = () => {
  const [, createGiftCardPaymentIntent] = useCreateGiftCardPaymentIntentMutation();

  return useCallback(
    async (input: CreateGiftCardPaymentIntentMutationVariables['input']) => {
      const response = await createGiftCardPaymentIntent({ input });

      const orderId = response.data?.createGiftCardPaymentIntent?.orderId;
      const paymentIntentId = response.data?.createGiftCardPaymentIntent?.id;
      const clientSecret = response.data?.createGiftCardPaymentIntent?.secret;

      if (!paymentIntentId || !clientSecret || !orderId) {
        throw new Error(); // caught by the Stripe integration.
      }

      return {
        orderId,
        paymentIntentId,
        clientSecret,
      };
    },
    [createGiftCardPaymentIntent],
  );
};
